export const VALUATION_SUMMARY_SLUG = 'valuation-summary';
export const ALLOCATION_SCENARIOS_SLUG = 'allocation-scenarios';
